import template from './sortable.html';

export const sortableComponent = {
  name: 'sortable',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    key: '=',
    currentKey: '=',
    order: '=',
  },
};
